import { createSelector } from 'reselect';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import { LINK_TYPE } from 'constants/general';
import { DISPLAY_SUMMARY_OVERVIEW, DISPLAY_SUMMARY_OVERVIEW_MANAGER } from 'features/common/acl/constants';
import user from 'features/views/user';

import configCP from './configCP';

const { checkRole } = user.utils;

const checkAccess = createSelector(
	(_, item) => item,
	user.selectors.getCurrentRole,
	user.selectors.getHasKmpSellerSubordinates,
	user.selectors.getHasSubordinates,
	(state) => hasPermissionByIds(state)(DISPLAY_SUMMARY_OVERVIEW),
	(state) => hasPermissionByIds(state)(DISPLAY_SUMMARY_OVERVIEW_MANAGER),
	(
		item,
		currentRole,
		hasKMPSubordinates,
		hasUserSubordinates,
		hasSellerPpzDashboardPerm,
		hasManagerDashboardPerm,
	) => {
		return checkRole(
			item.link,
			currentRole,
			hasKMPSubordinates,
			hasUserSubordinates,
			hasSellerPpzDashboardPerm,
			hasManagerDashboardPerm,
		);
	},
);

export const getAccessItems = (state) => {
	return configCP.filter((item) => checkAccess(state, item));
};

export const getExternalLinks = createSelector(getAccessItems, (accessibleItems) => {
	return accessibleItems.filter((item) => item.linkType === LINK_TYPE.EXTERNAL);
});

export const getInternalLinks = createSelector(getAccessItems, (accessibleItems) => {
	return accessibleItems.filter((item) => item.linkType === LINK_TYPE.LOCAL);
});
